import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { convertMinutesToHours } from '@/utils/durationHelper';

const { Text } = Typography;

type DurationDisplayProps = {
  duration: number;
  label: string;
  type?: 'primary' | 'secondary';
  strong?: boolean;
};

export function DurationDisplay({
  duration,
  label,
  type = 'primary',
  strong = false,
}: DurationDisplayProps) {
  const { t } = useTranslation();
  const hours = convertMinutesToHours(duration);

  return (
    <Text type={type === 'secondary' ? 'secondary' : undefined} strong={strong}>
      {label}: {t('common:minuteWithCount', { count: duration })}
      {` (${t('common:hourWithCount', { count: hours })})`}
    </Text>
  );
}
